/** `/c/$companyId/journals/$draftId` — a manual journal draft, or a posted one with its entry. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { JournalEditor } from "../journals/JournalEditor";

export const Route = createFileRoute("/_auth/c/$companyId/journals/$draftId")({
  component: Journal,
});

function Journal(): JSX.Element {
  const { companyId, draftId } = Route.useParams();
  return <JournalEditor companyId={companyId} draftId={draftId} />;
}
